<template>
  <div>
    <div v-for="(medication, index) in editMedications" :key="index" class="tw-flex tw-mb-4">
      <base-select
        :value="medication.value"
        :optgroups="getMedicationsOptGroups(medication)"
        :label="`${medicationsLabel} ${index + 1}`"
        :placeholder="`Select ${medicationsLabel.toLowerCase()}`"
        @input="updateMedications(index, $event)"
        class="tw-flex-grow"
      />
      <base-button class="tw-my-auto tw-ml-3 tw-mr-1.5" size="sm" type="text" @click="clearMedication(index)">Clear</base-button>
    </div>
    <div class="tw--mt-3" v-if="canAddMedication">
      <base-button type="text" size="sm" @click="addMedication"> Add {{ medicationsLabel }} </base-button>
    </div>
  </div>
</template>

<script>
import { orderBy, uniq, cloneDeep } from "lodash";

export default {
  props: {
    editMedications: Array,
    allowedMedications: Array,
    maxMedications: Number,
    isSaving: Boolean,
    hideSave: Boolean,
    medicationsLabel: {
      type: String,
      default: "Medication",
    },
  },
  computed: {
    canAddMedication() {
      return this.editMedications.length < this.maxMedications;
    },
  },
  methods: {
    getMedicationsOptGroups(medication) {
      const allAllowedMedications = [
        ...this.allowedMedications,
        ...(this.allowedMedications.find((am) => am.value === medication.value) || !medication.value
          ? []
          : [{ label: medication.label, value: medication.value, productGroup: medication.productGroup }]),
      ];

      const groups = orderBy(uniq(allAllowedMedications.map((m) => m.productGroup)));

      return groups.map((g) => ({
        label: g,
        options: orderBy(allAllowedMedications.filter((m) => m.productGroup === g), ["productGroup", "label"]),
      }));
    },
    clearMedication(index) {
      const copy = cloneDeep(this.editMedications);
      copy[index].value = null;
      copy[index].label = null;
      copy[index].productGroup = null;
      this.$emit("update:editMedications", copy);
    },
    addMedication() {
      const copy = cloneDeep(this.editMedications);
      copy.push({ value: null, label: null, productGroup: null });
      this.$emit("update:editMedications", copy);
    },
    updateMedications(index, event) {
      const copy = cloneDeep(this.editMedications);
      copy[index] = cloneDeep(this.allowedMedications.find((m) => m.value === event));
      this.$emit("update:editMedications", copy);
    },
  },
};
</script>
